import CommandeEnteteController from './commande.entete.controller';
import templateUrl from './commande.entete.html';

export default {
	bindings: {
		commande: '=',
		isOpen: '=',
		hasTransport: '=',
		sortedCommandeLignes: '=',
		loadSiteCommerciaux: '&',
		onChanged: '&'
	},
	template: templateUrl,
	controller: CommandeEnteteController
};
